import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const LS_KEY = "gmm_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(LS_KEY, JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.id);
      const maxQty = product.inventory_type === "one_of_one" ? 1 : product.inventory_quantity;
      if (existing) {
        return prev.map((i) => i.product_id === product.id
          ? { ...i, quantity: Math.min(maxQty, i.quantity + qty) } : i);
      }
      return [...prev, {
        product_id: product.id, title: product.title, slug: product.slug,
        price: product.price, image: product.primary_image,
        inventory_type: product.inventory_type, inventory_quantity: product.inventory_quantity,
        quantity: Math.min(maxQty, qty),
      }];
    });
    setOpen(true);
  };
  const remove = (product_id) => setItems((p) => p.filter((i) => i.product_id !== product_id));
  const updateQty = (product_id, quantity) => setItems((p) => p.map((i) =>
    i.product_id === product_id ? { ...i, quantity: Math.max(1, Math.min(i.inventory_quantity || 99, quantity)) } : i));
  const clear = () => setItems([]);
  const count = items.reduce((a, b) => a + b.quantity, 0);
  const subtotal = items.reduce((a, b) => a + b.quantity * b.price, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, updateQty, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
